/* tslint:disable */
/* eslint-disable */
/**
 * ELEMENTS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface Timezone
 */
export interface Timezone {
    /**
     * 
     * @type {string}
     * @memberof Timezone
     */
    value: string;
    /**
     * 
     * @type {string}
     * @memberof Timezone
     */
    readonly name: string;
}

export function TimezoneFromJSON(json: any): Timezone {
    return TimezoneFromJSONTyped(json, false);
}

export function TimezoneFromJSONTyped(json: any, ignoreDiscriminator: boolean): Timezone {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'value': json['value'],
        'name': json['name'],
    };
}

export function TimezoneToJSON(value?: Timezone | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'value': value.value,
    };
}


